export default __webpack_public_path__ + "dd3c6c5522cda39b4f9370c7a1ed1296.png";